"use client";

import { useState, useRef, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ChevronDownIcon, ChevronUpIcon } from "lucide-react";

export function InnDesc({ inn }: { inn: InnVM }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const checkOverflow = () => {
      if (contentRef.current) {
        const element = contentRef.current;
        // Reset to clamped state to measure
        element.style.webkitLineClamp = "5";
        element.style.display = "-webkit-box";

        // Check if content is overflowing
        const isOverflowing = element.scrollHeight > element.clientHeight;
        setShowButton(isOverflowing);

        // If expanded, remove clamp
        if (isExpanded) {
          element.style.webkitLineClamp = "unset";
          element.style.display = "block";
        }
      }
    };

    checkOverflow();

    // Recheck on window resize
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, [isExpanded]);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  if (!inn.description || inn.description.trim() === "") {
    return null;
  }

  return (
    <div className={`space-y-2`}>
      <div className={`text-base-foreground text-lg font-semibold`}>Opis</div>
      <div
        ref={contentRef}
        className="text-muted-foreground max-w-[768px] overflow-hidden text-sm text-ellipsis"
        style={{
          display: isExpanded ? "block" : "-webkit-box",
          WebkitLineClamp: isExpanded ? "unset" : 5,
          WebkitBoxOrient: "vertical",
          lineHeight: "1.5",
        }}
        dangerouslySetInnerHTML={{ __html: inn.description }}
      />

      {showButton && (
        <Button
          variant="ghost"
          size="sm"
          onClick={toggleExpanded}
          className="text-muted-foreground hover:text-foreground h-auto p-1 text-sm"
        >
          {isExpanded ? (
            <>
              <ChevronUpIcon size={16} />
              Pokaż mniej
            </>
          ) : (
            <>
              <ChevronDownIcon size={16} />
              Wyświetl cały opis
            </>
          )}
        </Button>
      )}
    </div>
  );
}
